/**
 * Godkännande av ombyggnads- och ändringsåtgärder enligt 12 kap. 18 d §
 * jordabalken — composition.
 *
 * Connected under the 18 e Meddelande (same renovation case, same parties
 * and lägenhet). The landlord appears in the panels but does not sign; the
 * tenant(s) do.
 */
import { COMPOSITION_SCHEMA, COMPOSITION_VERSION } from '@hyranai/regta-document-ir';
const TITLE = 'Godkännande av ombyggnads- och ändringsåtgärder enligt 12 kap. 18 d § jordabalken';
const FORM_NUMBER = 'Formulär R-07';
const PREAMBLE = 'Hyresvärden inhämtar härmed hyresgästens godkännande av planerade ombyggnads- och ändringsåtgärder.';
const REPEAT = { part_ref: 'overenskommelse' };
export const godkannande18dV1 = (values = {}) => ({
    schema: COMPOSITION_SCHEMA,
    version: COMPOSITION_VERSION,
    documentKey: 'godkannande_18d',
    documentVersion: 'v1',
    title: TITLE,
    locale: 'sv-SE',
    meta: {
        category: 'Ombyggnad och ändring',
        shortTitle: 'Godkännande 18 d §',
        formNumber: FORM_NUMBER,
        statute: '12 kap. 18 d § jordabalken',
        signingMode: 'manual_delivery',
        signingPlacementAnchors: 'per-party-label',
        status: 'active',
        preamble: PREAMBLE,
        description: 'Hyresgästens godkännande av ombyggnads- och ändringsåtgärder enligt 12 kap. 18 d § jordabalken.',
        numberStyle: 'paragraph',
        partySlots: [
            {
                id: 'lessor',
                label: 'Hyresvärd',
                role: 'lessor',
                ordinal: 0,
                required: true,
                signs: false,
                help: 'Hyresvärdens uppgifter visas i sidhuvudet — undertecknar inte.',
            },
            {
                id: 'lessee_primary',
                label: 'Hyresgäst (primär)',
                signingLabel: 'Hyresgäst 1',
                role: 'lessee',
                ordinal: 0,
                required: true,
                signs: true,
            },
            {
                id: 'lessee_co',
                label: 'Medhyresgäst',
                signingLabel: 'Eventuell hyresgäst 2',
                role: 'lessee',
                ordinal: 1,
                signs: true,
                help: 'Valfritt — lägg till om kontraktet har två hyresgäster.',
            },
        ],
        propertySlots: [{ id: 'property', label: 'Fastighet', multi: false, required: true }],
        connectedTo: ['meddelande_18e'],
        inheritFromParent: {
            parties: 'by-role-ordinal',
            property: true,
            values: [
                { key: 'apartment_official_number', fromParentKey: 'apartment_official_number' },
                { key: 'apartment_rooms', fromParentKey: 'apartment_rooms' },
                { key: 'apartment_area_sqm', fromParentKey: 'apartment_area_sqm' },
            ],
        },
        titleSuffix: { key: 'apartment_official_number', prefix: 'lgh' },
    },
    values,
    blocks: [
        { instanceId: 'letterhead', blockRef: 'common.letterhead@v1', slot: 'letterhead', input: { title: TITLE, form_number: FORM_NUMBER } },
        { instanceId: 'footer', blockRef: 'common.page-footer@v1', slot: 'footer', input: { form_number: FORM_NUMBER } },
        { instanceId: 'preamble', blockRef: 'common.preamble@v1', input: { text: PREAMBLE } },
        { instanceId: 'hyresvard', blockRef: 'godkannande_18d.hyresvard@v1', input: {} },
        { instanceId: 'hyresobjekt', blockRef: 'godkannande_18d.hyresobjekt@v1', input: {} },
        { instanceId: 'hyresgast', blockRef: 'godkannande_18d.hyresgast@v1', input: { with_contact: true } },
        { instanceId: 'byggbeskrivning', blockRef: 'godkannande_18d.byggbeskrivning@v1', input: {} },
        { instanceId: 'bilagor', blockRef: 'godkannande_18d.bilagor@v1', input: {} },
        { instanceId: 'overenskommelse-rubrik', blockRef: 'godkannande_18d.overenskommelse-rubrik@v1', input: {} },
        { instanceId: 'hyresvard-sida-2', blockRef: 'godkannande_18d.hyresvard@v1', input: { ...REPEAT, restart_numbering: true } },
        { instanceId: 'hyresobjekt-sida-2', blockRef: 'godkannande_18d.hyresobjekt@v1', input: REPEAT },
        { instanceId: 'hyresgast-sida-2', blockRef: 'godkannande_18d.hyresgast@v1', input: { ...REPEAT, with_contact: false } },
        // Continue page 2's restarted sequence: § 4 and § 5 after the repeated § 1–3.
        { instanceId: 'godkannande', blockRef: 'godkannande_18d.godkannande@v1', input: {} },
        { instanceId: 'underskrift', blockRef: 'godkannande_18d.underskrift@v1', input: { heading: false } },
        { instanceId: 'evakueringsavtal', blockRef: 'godkannande_18d.evakueringsavtal@v1', input: {} },
    ],
});
//# sourceMappingURL=godkannande_18d.js.map